module["exports"] = [
  "0#-#####-####",
  "0##-###-####",
  "0##-####-####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ko/phone_number/formats.js
// module id = 794
// module chunks = 0